import { ColumnsType } from 'antd/es/table';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  ProjectTemplateSpaceData,
  setProjectTemplateActiveRecord,
} from 'data/templates/projects';
import { useTranslation } from 'hooks/use-translation';
import { StatusNameCell } from './status-name-cell';

export const useProjectTemplateColumns =
  (): ColumnsType<ProjectTemplateSpaceData> => {
    const dispatch = useDispatch();
    const spaceNames = useTranslation('spaces_name');

    const onActivateRow = useCallback(
      (row: ProjectTemplateSpaceData) => {
        dispatch(setProjectTemplateActiveRecord(row));
      },
      [dispatch],
    );

    return [
      {
        title: spaceNames,
        dataIndex: 'name',
        key: 'name',
        width: '375px',
        render: (_, data: ProjectTemplateSpaceData) => (
          <StatusNameCell data={data} onClick={() => onActivateRow(data)} />
        ),
      },
    ].map((col) => {
      return col;
    });
  };
